@if (appUpdate.updateReady()) {
  <section class="update-notice" role="status" aria-live="polite">
    <h2 class="update-notice-title">{{ 'APP_UPDATE.TITLE' | translate }}</h2>
    <p class="update-notice-message">{{ 'APP_UPDATE.MESSAGE' | translate }}</p>
    <ion-button
      color="primary"
      size="small"
      [disabled]="appUpdate.applying()"
      (click)="appUpdate.apply()"
    >
      <ion-icon slot="start" name="refresh-outline" aria-hidden="true"></ion-icon>
      {{ (appUpdate.applying() ? 'APP_UPDATE.UPDATING' : 'APP_UPDATE.UPDATE_NOW') | translate }}
    </ion-button>
  </section>
}
